const liquidityData = [
  {
    month: ["2021", "Aug"],
    liquidAssets: 3441645.23,
    totalExpenses: 1329493.89,
    totalRevenue: 1056302.74,
    totalCurrentLiabilities: 6826698.13,
    currentAssetsNetInventory: 2620588.4,
    currentRatio: 0.55,
    quickRatio: 0.12,
    cashRatio: 0.12,
    cash: 836829.02,
    netIncome: -273191.15,
    ebitda: -261682.45,
    currentAssets: 3729507.14,
    runway: 3.06,
  },
  {
    month: ["2021", "Sep"],
    liquidAssets: 3868935.52,
    totalExpenses: 1615094.14,
    totalRevenue: 829310.85,
    totalCurrentLiabilities: 8039086.71,
    currentAssetsNetInventory: 3492863.33,
    currentRatio: 0.52,
    quickRatio: 0.05,
    cashRatio: 0.05,
    cash: 383270.55,
    netIncome: -785783.29,
    ebitda: -710855.77,
    currentAssets: 4156921.83,
    runway: 0.49,
  },
  {
    month: ["2021", "Oct"],
    liquidAssets: 4798523.89,
    totalExpenses: 2042272.13,
    totalRevenue: 2061491.35,
    totalCurrentLiabilities: 8970799.03,
    currentAssetsNetInventory: 3979670.88,
    currentRatio: 0.57,
    quickRatio: 0.09,
    cashRatio: 0.09,
    cash: 801144.55,
    netIncome: 19219.22,
    ebitda: 29210.15,
    currentAssets: 5127051.12,
    runway: Infinity,
  },
  {
    month: ["2021", "Nov"],
    liquidAssets: 5548845.97,
    totalExpenses: 2933067.96,
    totalRevenue: 3116471.59,
    totalCurrentLiabilities: 9575735.84,
    currentAssetsNetInventory: 3704334.4,
    currentRatio: 0.62,
    quickRatio: 0.19,
    cashRatio: 0.15,
    cash: 1453189.69,
    netIncome: 183403.63,
    ebitda: 223837.94,
    currentAssets: 5907671.14,
    runway: Infinity,
  },
  {
    month: ["2021", "Dec"],
    liquidAssets: 5035201.15,
    totalExpenses: 3384100.33,
    totalRevenue: 3247412.49,
    totalCurrentLiabilities: 9212443.52,
    currentAssetsNetInventory: 2941339.93,
    currentRatio: 0.59,
    quickRatio: 0.23,
    cashRatio: 0.23,
    cash: 2093477.41,
    netIncome: -136687.84,
    ebitda: -133300.42,
    currentAssets: 5410032.74,
    runway: 15.32,
  },
  {
    month: ["2022", "Jan"],
    liquidAssets: 3932703.98,
    totalExpenses: 1722767.11,
    totalRevenue: 1225423.81,
    totalCurrentLiabilities: 8588523.52,
    currentAssetsNetInventory: 2988447.71,
    currentRatio: 0.5,
    quickRatio: 0.11,
    cashRatio: 0.11,
    cash: 965303.76,
    netIncome: -497343.3,
    ebitda: -496804.59,
    currentAssets: 4316752.9,
    runway: 1.94,
  },
  {
    month: ["2022", "Feb"],
    liquidAssets: 4479273.21,
    totalExpenses: 1862520.31,
    totalRevenue: 1488528.38,
    totalCurrentLiabilities: 9517768.8,
    currentAssetsNetInventory: 3105310.11,
    currentRatio: 0.51,
    quickRatio: 0.14,
    cashRatio: 0.14,
    cash: 1371971.53,
    netIncome: -373991.93,
    ebitda: -334126.64,
    currentAssets: 4873612.06,
    runway: 3.67,
  },
  {
    month: ["2022", "Mar"],
    liquidAssets: 3704489.59,
    totalExpenses: 1598905.89,
    totalRevenue: 1370241.74,
    totalCurrentLiabilities: 8966187.77,
    currentAssetsNetInventory: 3358477.08,
    currentRatio: 0.46,
    quickRatio: 0.04,
    cashRatio: 0.04,
    cash: 349492.07,
    netIncome: -228664.15,
    ebitda: -227476.2,
    currentAssets: 4098519.41,
    runway: 1.53,
  },
  {
    month: ["2022", "Apr"],
    liquidAssets: 3957060.37,
    totalExpenses: 1473206.29,
    totalRevenue: 997813.92,
    totalCurrentLiabilities: 9689684.02,
    currentAssetsNetInventory: 3566748.06,
    currentRatio: 0.45,
    quickRatio: 0.04,
    cashRatio: 0.04,
    cash: 421236.79,
    netIncome: -475392.37,
    ebitda: -474566.67,
    currentAssets: 4352297.39,
    runway: 0.89,
  },
  {
    month: ["2022", "May"],
    liquidAssets: 3610983.37,
    totalExpenses: 1555958.11,
    totalRevenue: 1276291.23,
    totalCurrentLiabilities: 9622886.84,
    currentAssetsNetInventory: 3525358.19,
    currentRatio: 0.42,
    quickRatio: 0.01,
    cashRatio: 0.01,
    cash: 119722.82,
    netIncome: -279666.88,
    ebitda: -283093.72,
    currentAssets: 4011406.33,
    runway: 0.43,
  },
  {
    month: ["2022", "Jun"],
    liquidAssets: 4212280.18,
    totalExpenses: 1476781.5,
    totalRevenue: 1147775.8,
    totalCurrentLiabilities: 10548883.5,
    currentAssetsNetInventory: 3799373.94,
    currentRatio: 0.44,
    quickRatio: 0.04,
    cashRatio: 0.04,
    cash: 412926.4,
    netIncome: -329005.7,
    ebitda: -328131.99,
    currentAssets: 4614893.14,
    runway: 1.26,
  },
  {
    month: ["2022", "Jul"],
    liquidAssets: 4465389.57,
    totalExpenses: 1394566.78,
    totalRevenue: 968255.47,
    totalCurrentLiabilities: 11232364.5,
    currentAssetsNetInventory: 3960580.88,
    currentRatio: 0.43,
    quickRatio: 0.04,
    cashRatio: 0.04,
    cash: 496691.42,
    netIncome: -426311.31,
    ebitda: -426064.94,
    currentAssets: 4869490.23,
    runway: 1.17,
  },
  {
    month: ["2022", "Aug"],
    liquidAssets: 4654583.25,
    totalExpenses: 1697850.86,
    totalRevenue: 1460722.01,
    totalCurrentLiabilities: 11708685.42,
    currentAssetsNetInventory: 4309054.85,
    currentRatio: 0.44,
    quickRatio: 0.03,
    cashRatio: 0.03,
    cash: 299495.54,
    netIncome: -237128.85,
    ebitda: -231432.52,
    currentAssets: 5108559.22,
    runway: 1.26,
  },
  {
    month: ["2022", "Sep"],
    liquidAssets: 4903765.67,
    totalExpenses: 1822446.52,
    totalRevenue: 903691.02,
    totalCurrentLiabilities: 12892637.78,
    currentAssetsNetInventory: 4713099.42,
    currentRatio: 0.42,
    quickRatio: 0.01,
    cashRatio: 0.01,
    cash: 144536.11,
    netIncome: -918755.5,
    ebitda: -908612.45,
    currentAssets: 5382865.85,
    runway: 0.16,
  },
  {
    month: ["2022", "Oct"],
    liquidAssets: 5317295.03,
    totalExpenses: 2637975.26,
    totalRevenue: 2572904.85,
    totalCurrentLiabilities: 13362852.65,
    currentAssetsNetInventory: 4722439.76,
    currentRatio: 0.43,
    quickRatio: 0.04,
    cashRatio: 0.04,
    cash: 511916.49,
    netIncome: -65070.41,
    ebitda: -41330.69,
    currentAssets: 5808381.85,
    runway: 7.87,
  },
  {
    month: ["2022", "Nov"],
    liquidAssets: 5845771.54,
    totalExpenses: 3076061.79,
    totalRevenue: 4061811.53,
    totalCurrentLiabilities: 12942951.0,
    currentAssetsNetInventory: 4115392.56,
    currentRatio: 0.49,
    quickRatio: 0.13,
    cashRatio: 0.12,
    cash: 1500152.8,
    netIncome: 985749.74,
    ebitda: 996662.53,
    currentAssets: 6370637.97,
    runway: Infinity,
  },
  {
    month: ["2022", "Dec"],
    liquidAssets: 4270844.01,
    totalExpenses: 2792296.38,
    totalRevenue: 3473715.02,
    totalCurrentLiabilities: 10674817.54,
    currentAssetsNetInventory: 3457645.51,
    currentRatio: 0.45,
    quickRatio: 0.08,
    cashRatio: 0.07,
    cash: 776161.2,
    netIncome: 681418.64,
    ebitda: 915443.82,
    currentAssets: 4796092.94,
    runway: Infinity,
  },
  {
    month: ["2023", "Jan"],
    liquidAssets: 4560549.23,
    totalExpenses: 1868864.33,
    totalRevenue: 1457363.91,
    totalCurrentLiabilities: 11370077.59,
    currentAssetsNetInventory: 3180649.46,
    currentRatio: 0.45,
    quickRatio: 0.12,
    cashRatio: 0.13,
    cash: 1496772.12,
    netIncome: -411500.42,
    ebitda: -408923.78,
    currentAssets: 5103058.16,
    runway: 3.64,
  },
  {
    month: ["2023", "Feb"],
    liquidAssets: 3085608.38,
    totalExpenses: 1093437.37,
    totalRevenue: 651704.91,
    totalCurrentLiabilities: 10336212.12,
    currentAssetsNetInventory: 3227560.42,
    currentRatio: 0.35,
    quickRatio: -0.01,
    cashRatio: 0.0,
    cash: 35759.9,
    netIncome: -441732.46,
    ebitda: -437982.85,
    currentAssets: 3640251.71,
    runway: 0.08,
  },
  {
    month: ["2023", "Mar"],
    liquidAssets: 3291250.89,
    totalExpenses: 1336842.78,
    totalRevenue: 1064881.14,
    totalCurrentLiabilities: 10821890.24,
    currentAssetsNetInventory: 3173384.43,
    currentRatio: 0.36,
    quickRatio: 0.01,
    cashRatio: 0.03,
    cash: 330112.56,
    netIncome: -271961.64,
    ebitda: -268249.95,
    currentAssets: 3859687.82,
    runway: 1.21,
  },
  {
    month: ["2023", "Apr"],
    liquidAssets: 3916742.85,
    totalExpenses: 1009553.27,
    totalRevenue: 644017.64,
    totalCurrentLiabilities: 11111522.44,
    currentAssetsNetInventory: 3311785.33,
    currentRatio: 0.4,
    quickRatio: 0.05,
    cashRatio: 0.08,
    cash: 834658.4,
    netIncome: -365535.63,
    ebitda: -362322.35,
    currentAssets: 4497419.78,
    runway: 2.28,
  },
  {
    month: ["2023", "May"],
    liquidAssets: 4240122.86,
    totalExpenses: 1113203.68,
    totalRevenue: 970982.72,
    totalCurrentLiabilities: 10808866.42,
    currentAssetsNetInventory: 3303024.29,
    currentRatio: 0.44,
    quickRatio: 0.09,
    cashRatio: 0.11,
    cash: 1189551.45,
    netIncome: -142220.96,
    ebitda: -138217.53,
    currentAssets: 4794814.85,
    runway: 8.36,
  },
  {
    month: ["2023", "Jun"],
    liquidAssets: 4149607.61,
    totalExpenses: 784139.08,
    totalRevenue: 669718.47,
    totalCurrentLiabilities: 10807651.21,
    currentAssetsNetInventory: 3514407.29,
    currentRatio: 0.43,
    quickRatio: 0.06,
    cashRatio: 0.08,
    cash: 853773.23,
    netIncome: -114420.61,
    ebitda: -110445.3,
    currentAssets: 4677936.2,
    runway: 7.46,
  },
  {
    month: ["2023", "Jul"],
    liquidAssets: 4019486.96,
    totalExpenses: 1010770.87,
    totalRevenue: 744590.0,
    totalCurrentLiabilities: 10939675.52,
    currentAssetsNetInventory: 3667893.39,
    currentRatio: 0.41,
    quickRatio: 0.03,
    cashRatio: 0.05,
    cash: 565946.54,
    netIncome: -266180.87,
    ebitda: -261339.09,
    currentAssets: 4522535.55,
    runway: 2.13,
  },
  {
    month: ["2023", "Aug"],
    liquidAssets: 4755751.32,
    totalExpenses: 1050008.09,
    totalRevenue: 1461633.43,
    totalCurrentLiabilities: 11272654.77,
    currentAssetsNetInventory: 3883059.14,
    currentRatio: 0.47,
    quickRatio: 0.08,
    cashRatio: 0.09,
    cash: 1051243.87,
    netIncome: 411625.34,
    ebitda: 478974.27,
    currentAssets: 5250338.41,
    runway: Infinity,
  },
  {
    month: ["2023", "Sep"],
    liquidAssets: 4509263.18,
    totalExpenses: 1482656.78,
    totalRevenue: 1148165.85,
    totalCurrentLiabilities: 11430156.34,
    currentAssetsNetInventory: 4386350.57,
    currentRatio: 0.44,
    quickRatio: 0.01,
    cashRatio: 0.02,
    cash: 229324.62,
    netIncome: -334490.93,
    ebitda: -330344.04,
    currentAssets: 4975973.73,
    runway: 0.69,
  },
  {
    month: ["2023", "Oct"],
    liquidAssets: 5742972.67,
    totalExpenses: 2541699.01,
    totalRevenue: 2708776.66,
    totalCurrentLiabilities: 12683379.05,
    currentAssetsNetInventory: 4587714.92,
    currentRatio: 0.5,
    quickRatio: 0.09,
    cashRatio: 0.09,
    cash: 1177695.44,
    netIncome: 167077.65,
    ebitda: 214908.24,
    currentAssets: 6322710.73,
    runway: Infinity,
  },
  {
    month: ["2023", "Nov"],
    liquidAssets: 6648302.65,
    totalExpenses: 2999664.0,
    totalRevenue: 4042095.01,
    totalCurrentLiabilities: 12947188.76,
    currentAssetsNetInventory: 3847906.43,
    currentRatio: 0.57,
    quickRatio: 0.22,
    cashRatio: 0.21,
    cash: 2753910.17,
    netIncome: 1042431.01,
    ebitda: 1047403.41,
    currentAssets: 7424435.22,
    runway: Infinity,
  },
  {
    month: ["2023", "Dec"],
    liquidAssets: 5871865.99,
    totalExpenses: 2969789.44,
    totalRevenue: 3560257.66,
    totalCurrentLiabilities: 11928462.12,
    currentAssetsNetInventory: 3253838.48,
    currentRatio: 0.56,
    quickRatio: 0.22,
    cashRatio: 0.22,
    cash: 2623131.82,
    netIncome: 590468.22,
    ebitda: 1142678.98,
    currentAssets: 6666324.52,
    runway: Infinity,
  },
  {
    month: ["2024", "Jan"],
    liquidAssets: 5506855.3,
    totalExpenses: 1648441.3,
    totalRevenue: 1357548.17,
    totalCurrentLiabilities: 11822160.92,
    currentAssetsNetInventory: 3323274.73,
    currentRatio: 0.53,
    quickRatio: 0.18,
    cashRatio: 0.18,
    cash: 2138036.21,
    netIncome: -290893.13,
    ebitda: -288098.75,
    currentAssets: 6293251.78,
    runway: 7.35,
  },
  {
    month: ["2024", "Feb"],
    liquidAssets: 5063132.98,
    totalExpenses: 1523248.15,
    totalRevenue: 1412332.92,
    totalCurrentLiabilities: 11674723.31,
    currentAssetsNetInventory: 3397868.92,
    currentRatio: 0.5,
    quickRatio: 0.14,
    cashRatio: 0.13,
    cash: 1564853.85,
    netIncome: -110915.23,
    ebitda: -27314.47,
    currentAssets: 5840229.8,
    runway: 14.11,
  },
  {
    month: ["2024", "Mar"],
    liquidAssets: 4855452.5,
    totalExpenses: 1244962.02,
    totalRevenue: 1109826.56,
    totalCurrentLiabilities: 11689739.0,
    currentAssetsNetInventory: 3438593.5,
    currentRatio: 0.48,
    quickRatio: 0.12,
    cashRatio: 0.1,
    cash: 1221752.51,
    netIncome: -135135.46,
    ebitda: -130093.38,
    currentAssets: 5619732.95,
    runway: 9.04,
  },
  {
    month: ["2024", "Apr"],
    liquidAssets: 4172322.51,
    totalExpenses: 1086640.48,
    totalRevenue: 854810.07,
    totalCurrentLiabilities: 11326781.3,
    currentAssetsNetInventory: 3516607.4,
    currentRatio: 0.43,
    quickRatio: 0.06,
    cashRatio: 0.04,
    cash: 419327.05,
    netIncome: -231830.41,
    ebitda: -227585.66,
    currentAssets: 4925608.18,
    runway: 1.81,
  },
  {
    month: ["2024", "May"],
    liquidAssets: 5525829.13,
    totalExpenses: 1263267.12,
    totalRevenue: 1304298.49,
    totalCurrentLiabilities: 12859840.22,
    currentAssetsNetInventory: 3440716.16,
    currentRatio: 0.49,
    quickRatio: 0.16,
    cashRatio: 0.14,
    cash: 1758261.13,
    netIncome: 41031.37,
    ebitda: 128549.29,
    currentAssets: 6271539.56,
    runway: Infinity,
  },
  {
    month: ["2024", "Jun"],
    liquidAssets: 5284191.3,
    totalExpenses: 938361.93,
    totalRevenue: 778806.57,
    totalCurrentLiabilities: 12807078.09,
    currentAssetsNetInventory: 3578837.32,
    currentRatio: 0.47,
    quickRatio: 0.13,
    cashRatio: 0.1,
    cash: 1325360.54,
    netIncome: -159555.36,
    ebitda: -145428.41,
    currentAssets: 5988823.75,
    runway: 8.31,
  },
  {
    month: ["2024", "Jul"],
    liquidAssets: 4645681.19,
    totalExpenses: 1352657.5,
    totalRevenue: 819763.32,
    totalCurrentLiabilities: 12774513.23,
    currentAssetsNetInventory: 3785836.72,
    currentRatio: 0.42,
    quickRatio: 0.07,
    cashRatio: 0.04,
    cash: 456598.43,
    netIncome: -532894.18,
    ebitda: -528576.95,
    currentAssets: 5328174.75,
    runway: 0.86,
  },
  {
    month: ["2024", "Aug"],
    liquidAssets: 4908545.89,
    totalExpenses: 1197274.62,
    totalRevenue: 1212828.82,
    totalCurrentLiabilities: 13092680.65,
    currentAssetsNetInventory: 3991130.32,
    currentRatio: 0.43,
    quickRatio: 0.07,
    cashRatio: 0.04,
    cash: 515308.36,
    netIncome: 15554.2,
    ebitda: 22798.87,
    currentAssets: 5569926.84,
    runway: Infinity,
  },
  {
    month: ["2024", "Sep"],
    liquidAssets: 5201638.28,
    totalExpenses: 1794280.02,
    totalRevenue: 1310645.84,
    totalCurrentLiabilities: 14000076.96,
    currentAssetsNetInventory: 4349052.04,
    currentRatio: 0.42,
    quickRatio: 0.06,
    cashRatio: 0.03,
    cash: 474504.22,
    netIncome: -483634.18,
    ebitda: -302181.54,
    currentAssets: 5907624.74,
    runway: 0.98,
  },
  {
    month: ["2024", "Oct"],
    liquidAssets: 5571499.41,
    totalExpenses: 2155931.88,
    totalRevenue: 1992038.87,
    totalCurrentLiabilities: 14588841.52,
    currentAssetsNetInventory: 4454007.78,
    currentRatio: 0.43,
    quickRatio: 0.08,
    cashRatio: 0.07,
    cash: 980222.92,
    netIncome: -163893.01,
    ebitda: -166876.94,
    currentAssets: 6263633.9,
    runway: 5.98,
  },
  {
    month: ["2024", "Nov"],
    liquidAssets: 6117144.64,
    totalExpenses: 2344461.63,
    totalRevenue: 3168315.18,
    totalCurrentLiabilities: 14438556.79,
    currentAssetsNetInventory: 4099767.64,
    currentRatio: 0.47,
    quickRatio: 0.14,
    cashRatio: 0.12,
    cash: 1696292.61,
    netIncome: 823853.55,
    ebitda: 904849.13,
    currentAssets: 6841531.83,
    runway: Infinity,
  },
  {
    month: ["2024", "Dec"],
    liquidAssets: 6119622.88,
    totalExpenses: 4282632.46,
    totalRevenue: 4392768.15,
    totalCurrentLiabilities: 12905116.99,
    currentAssetsNetInventory: 3218207.27,
    currentRatio: 0.53,
    quickRatio: 0.22,
    cashRatio: 0.2,
    cash: 2574967.8,
    netIncome: 110135.69,
    ebitda: 689865.96,
    currentAssets: 6859737.05,
    runway: Infinity,
  },
  {
    month: ["2025", "Jan"],
    liquidAssets: 5250426.58,
    totalExpenses: 1743908.88,
    totalRevenue: 1200761.65,
    totalCurrentLiabilities: 12665526.42,
    currentAssetsNetInventory: 3307538.41,
    currentRatio: 0.47,
    quickRatio: 0.15,
    cashRatio: 0.13,
    cash: 1584024.86,
    netIncome: -543147.23,
    ebitda: -542199.64,
    currentAssets: 6006269.7,
    runway: 2.92,
  },
  {
    month: ["2025", "Feb"],
    liquidAssets: 5368252.96,
    totalExpenses: 1413600.15,
    totalRevenue: 1364382.34,
    totalCurrentLiabilities: 12923636.07,
    currentAssetsNetInventory: 3346380.39,
    currentRatio: 0.47,
    quickRatio: 0.16,
    cashRatio: 0.13,
    cash: 1647578.58,
    netIncome: -49217.81,
    ebitda: -44694.79,
    currentAssets: 6133366.77,
    runway: 33.48,
  },
  {
    month: ["2025", "Mar"],
    liquidAssets: 6341865.64,
    totalExpenses: 1415115.45,
    totalRevenue: 1520812.98,
    totalCurrentLiabilities: 12943247.56,
    currentAssetsNetInventory: 3466519.6,
    currentRatio: 0.55,
    quickRatio: 0.22,
    cashRatio: 0.19,
    cash: 2455371.49,
    netIncome: 105697.53,
    ebitda: 112243.9,
    currentAssets: 7101272.11,
    runway: Infinity,
  },
  {
    month: ["2025", "Apr"],
    liquidAssets: 5665791.26,
    totalExpenses: 1145675.38,
    totalRevenue: 725728.68,
    totalCurrentLiabilities: 12697365.79,
    currentAssetsNetInventory: 3538694.55,
    currentRatio: 0.51,
    quickRatio: 0.17,
    cashRatio: 0.13,
    cash: 1704202.32,
    netIncome: -419946.7,
    ebitda: -415232.58,
    currentAssets: 6425882.29,
    runway: 4.06,
  },
  {
    month: ["2025", "May"],
    liquidAssets: 5697728.36,
    totalExpenses: 1222203.34,
    totalRevenue: 1109996.95,
    totalCurrentLiabilities: 12899788.23,
    currentAssetsNetInventory: 3524026.21,
    currentRatio: 0.5,
    quickRatio: 0.17,
    cashRatio: 0.14,
    cash: 1753981.91,
    netIncome: -112206.39,
    ebitda: -108584.43,
    currentAssets: 6441922.75,
    runway: 15.63,
  },
  {
    month: ["2025", "Jun"],
    liquidAssets: 5878520.82,
    totalExpenses: 390781.96,
    totalRevenue: 765991.16,
    totalCurrentLiabilities: 12726899.82,
    currentAssetsNetInventory: 3764338.42,
    currentRatio: 0.52,
    quickRatio: 0.17,
    cashRatio: 0.13,
    cash: 1661007.56,
    netIncome: 375209.2,
    ebitda: 381408.26,
    currentAssets: 6654481.11,
    runway: Infinity,
  },
  {
    month: ["2025", "Jul"],
    liquidAssets: 5902546.56,
    totalExpenses: 15725.4,
    totalRevenue: 37494.53,
    totalCurrentLiabilities: 12731874.32,
    currentAssetsNetInventory: 3767649.5,
    currentRatio: 0.52,
    quickRatio: 0.17,
    cashRatio: 0.13,
    cash: 1684309.07,
    netIncome: 21769.13,
    ebitda: 21769.13,
    currentAssets: 6681206.85,
    runway: Infinity,
  },
];

export default liquidityData;
